<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="warningLetterCreateForm" (change)="warningLetterCreateFormChange()"
        (submit)="warningLetterCreateFormSubmit()">
        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"WARNING_LETTER_CREATE" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="button" class="btn btn-outline-secondary m-2 rounded-0"
                    routerLink="/scores-grades/warning-letters" *ngIf="!creating">
                    {{"CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i
                        class="fas fa-user-plus"></i>
                    {{"SAVE" | translate | titlecase }}</button>
                <app-loader [show]="creating"></app-loader>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-12">
                <div class="row bg-white border m-0 py-3 ">
                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-1">
                                <label class="font-bold"> {{ "LETTER_TYPE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="warntypeid">
                                    <option value="" [selected]="true">{{ "SELECT" | translate |
                                        titlecase
                                        }}</option>
                                    <option *ngFor="let field of letterTypes" value="{{field.id}}">
                                        {{(globals.lang == 'ar')? field.wtypeNameAr :
                                        field.wtypeNameEn}}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="warningLetterCreateForm.controls.warntypeid.touched && warningLetterCreateForm.controls.warntypeid.invalid && warningLetterCreateForm.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-1">
                                <label class="font-bold"> {{ "STUDENT" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="studentid">
                                    <option value="" [selected]="true">{{ "SELECT" | translate |
                                        titlecase
                                        }}</option>
                                    <option *ngFor="let field of allstudents" value="{{field.id}}">
                                        {{field.id.toString() + " - " + ((globals.lang == 'ar')?
                                        field.fullNameAr :
                                        field.fullNameEn)}}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="warningLetterCreateForm.controls.studentid.touched && warningLetterCreateForm.controls.studentid.invalid && warningLetterCreateForm.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-1">
                                <label class="font-bold"> {{ "COURSE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="subjectid"
                                    (change)="getTeachersByCourse()">
                                    <option value="" [selected]="true">{{ "SELECT" | translate |
                                        titlecase
                                        }}</option>
                                    <!-- <option value="770">{{ "static group" | translate |
                                        titlecase
                                        }}</option> -->
                                    <option *ngFor="let field of courses" value="{{field.subjectid}}">
                                        {{(globals.lang == 'ar')? field.subjectNameAr :
                                        field.subjectNameEn}} - ({{field.subjectCode}})</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="warningLetterCreateForm.controls.subjectid.touched && warningLetterCreateForm.controls.subjectid.invalid && warningLetterCreateForm.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-1">
                                <label class="font-bold"> {{ "TEACHER" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="teacherid">
                                    <option value="" [selected]="true">{{ "SELECT" | translate |
                                        titlecase
                                        }}</option>
                                    <option *ngFor="let field of teachers" value="{{field.id}}">
                                        {{(globals.lang == 'ar')? field.teacherNameAr :
                                        field.teacherNameEn}}- ({{field.teacherCode}})
                                    </option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="warningLetterCreateForm.controls.teacherid.touched && warningLetterCreateForm.controls.teacherid.invalid && warningLetterCreateForm.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-1">
                                <label class="font-bold"> {{ "NOTE" | translate | titlecase }}</label>
                                <textarea class="form-control" formControlName="remarks"> </textarea>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="warningLetterCreateForm.controls.remarks.touched && warningLetterCreateForm.controls.remarks.invalid && warningLetterCreateForm.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>